import React, {Component} from 'react';
import { Link } from 'react-router'

export default class Footer extends Component {
  render() {
    let year = new Date().getFullYear();
    return (
      <footer>
        <p>
          &copy; {year} Janes Colony
          &nbsp; &nbsp;| &nbsp;&nbsp;
          <Link to="/terms">Terms of Service</Link>
          &nbsp; &nbsp;| &nbsp;&nbsp;
          <Link to="/privacy">Privacy Policy</Link>
          &nbsp; &nbsp;| &nbsp;&nbsp;
          <Link to="/about">About</Link>
          &nbsp; &nbsp;| &nbsp;&nbsp;
          <Link to="/contact">Contact</Link>
        </p>
      </footer>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js